var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgWatch = function SvgWatch(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 11.445A21.332 21.332 0 0 0 15 15.39a20.612 20.612 0 0 0-5.25-3.945A18.38 18.38 0 0 1 15.09 0c3.18 3.18 4.875 7.26 5.16 11.445ZM15 20.175c3.139-4.789 8.438-8 14.5-8.168.276-.008.5.225.495.501C29.683 27.064 16.008 29.822 15 30 13.992 29.837.317 27.064.005 12.508a.488.488 0 0 1 .495-.501c6.062.168 11.361 3.38 14.5 8.168Zm.075-15.39A15.313 15.313 0 0 0 13.02 9.87L15 11.325l2.025-1.47a15.218 15.218 0 0 0-1.95-5.07ZM15 26.955s9-1.455 11.61-11.58C18 18 15 25.65 15 25.65S10.5 16.5 3.39 15.39C6 25.5 15 26.955 15 26.955Z",
    fill: "#fff"
  })));
};
export default SvgWatch;